export default function Spinner({ classNames }) {
  return (
    <>
      <div className={`wls-spinner border-primary border-l-transparent border-4 ${classNames}`} />
      <style jsx>
        {`
        .wls-spinner {
          margin: auto;
          display: block;
          border-radius: 50%;
          animation: lds-dual-ring 1.2s linear infinite;
        }
        @keyframes lds-dual-ring {
          0% {
          transform: rotate(0deg);
          }

          100% {
          transform: rotate(360deg);
          }
        }
      `}
      </style>
    </>
  );
}
